import axios from './axios'
import { Patient ,Data, Contatti  } from '@/../../EshJSLib/models/patient'



export async function fetchPatient(params) {
    const response = await axios.get(`api/patient/${params}`) ;
    return response.data;
}




export async function savePatient(params: Data) {
  
    const response = await axios.put(`/api/patient/${params.id_paziente}`,params);
    
    return response.data;
    
   
 }
 
 
 export async function deletePatient(params: Data) {
   
   
     const response = await axios.get(`api/patient`);
     // return response.data;
  }
  

export async function getCity(params: any) {
    const response = await axios.post(`/api/city/get_city?search=${params}`);
    return response.data;
}
export async function updateEmergenza(id:any, params:any) {
    const response = await axios.put(`/api/patient/${id}`, params);
    return response.data;
}

export async function updateConsenso(id:any, params:any) {
    const response = await axios.put(`/api/consenso/${id}`, params);
    return response.data;
}

export async function deleteEmergencyContact(id:Number){
    const response = await axios.delete(`/api/emergenza/${id}`);
    return response.data;
}

//  Modified by: Elena Simonoska
// Last modification date: 27.09.2023
// Changes: add function to delete emergency contact 